
class Timer {
  constructor({
      delay, //tiempo de espera entre cada step
      steps,  //no de steps
      callback_step,
      repeat=true,
      first_step=0
  }){
      this.delay = delay;
      this.steps = steps;
      this.callback_step = callback_step
      this.repeat = repeat;
      this.first_step =first_step
      this._current_step = this.first_step
      this.onAutoStop=()=>{}
  }


  play(){

      this._last_timer = setInterval(()=>{

          const new_step = (this._current_step + 1) < this.steps ? this._current_step+1 : ( this.repeat ? 0 : -1 )
          //console.log(new_step)
          if(new_step>-1){
              this._current_step = new_step
              this.callback_step(this._current_step)
          }else{
              this.pause()
          }
          if(new_step== -1){
              
              this.onAutoStop()
          }

      },this.delay)
  }

  pause(){
      window.clearInterval(this._last_timer)
  }

  destroy(){
      window.clearInterval(this._last_timer)
  }

  
    
}
export default Timer;
